import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EditorModule as ModMCE } from '@tinymce/tinymce-angular';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {MatTableModule} from '@angular/material/table';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { ProgramacionComponent } from './programacion.component';
import { VistaGenComponent } from './vista-gen/vista-gen.component';
import { CorreosComponent } from './correos/correos.component';
import { EditorComponent } from './editor/editor.component';
import { ModalRecoComponent } from './vista-gen/modal-reco/modal-reco.component';
import { ModalInfoComponent } from './editor/modal-info/modal-info.component';

@NgModule({
  declarations: [
    ProgramacionComponent,
    VistaGenComponent,
    CorreosComponent,
    EditorComponent,
    ModalRecoComponent,
    ModalInfoComponent
  ],
  imports: [
    CommonModule,
    ModMCE,
    FlexLayoutModule,
    TranslateModule,
    MatStepperModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatDividerModule,
    MatListModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaterialTimepickerModule,
    MatTableModule,
    MatProgressSpinnerModule
  ],
  entryComponents: [ModalRecoComponent,ModalInfoComponent]
})
export class ProgramacionModule { }
